import { IntlShape } from 'react-intl';
import { Document } from '@rossum/api-client/documents';
import { ParsedAttachmentStatus } from '../../../types/attachmentStatus';

export const resolveDetailForDocument = (
  document: Document,
  status: ParsedAttachmentStatus,
  originalTask: { documents: string[] },
  intl: IntlShape
) => {
  switch (status) {
    case 'uploads_failed':
      return intl.formatMessage({
        id: 'components.asyncTasksDialog.uploadError.default',
      });
    case 'filtered_by_hook_custom':
      return intl.formatMessage({
        id: 'components.asyncTasksDialog.item.document.attachmentStatus.filtered_by_hook_custom',
      });
    case 'filtered_by_queue_mime_type':
      return intl.formatMessage({
        id: 'components.asyncTasksDialog.item.document.attachmentStatus.filtered_by_queue_mime_type',
      });
    case 'filtered_by_insecure_mime_type':
      return intl.formatMessage({
        id: 'components.asyncTasksDialog.item.document.attachmentStatus.filtered_by_insecure_mime_type',
      });
    case 'broken_image':
      return intl.formatMessage({
        id: 'components.asyncTasksDialog.item.document.attachmentStatus.broken_image',
      });
    case 'extracted_archive':
      return intl.formatMessage(
        {
          id: 'components.asyncTasksDialog.item.document.attachmentStatus.extracted_archive',
        },
        {
          // subtract 1 because the `archive` itself is also in the list
          files: originalTask.documents.length - 1,
        }
      );
    case 'failed_to_extract':
      return intl.formatMessage({
        id: 'components.asyncTasksDialog.item.document.attachmentStatus.failed_to_extract',
      });
    case 'password_protected_archive':
      return intl.formatMessage({
        id: 'components.asyncTasksDialog.item.document.attachmentStatus.password_protected_archive',
      });

    default:
      return intl.formatMessage(
        {
          id: 'components.asyncTasksDialog.item.document.attachmentStatus.unknown',
        },
        { status: document.attachmentStatus }
      );
  }
};
